import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom'
import { IMaskInput } from "react-imask";
import {
  Typography,
  Dialog,
  useMediaQuery,
  Button,
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Table,
  TableContainer,
  TableRow,
  TableCell,
  TableHead,
  TableBody,
  Paper,
  TextField as InputText,
  OutlinedInput,
  MenuItem,
  styled, useTheme
} from '@mui/material';
import {
  Controller,
  useForm,
  useFormContext,
  FormProvider,
} from "react-hook-form";
import { FiberManualRecord, ArrowDropDown } from "@mui/icons-material";
import { deviceDetect, mobileModel, osVersion } from "react-device-detect"
import { makeStyles } from '@mui/styles'

import { CustomCounterAppBar, CustomLoadingOverlay, GenericDialog, Buttons } from "../../components";
import VisorPDF from "../../components/Visor/VisorPDF.js";
import VisorPdfViewer from "../../components/Visor/VisorPdfViewer.js";
import { useStyles } from "./CargarDocsStyles";

//import { mainStyles, theme } from "../../styles/Main.js";
import { executeSearchActions } from '../../store/actions'
import { useTranslation } from "react-i18next";

const TextField = styled(InputText)(({ theme }) => ({
  "& .MuiOutlinedInput-input": {
    height: 25,
    padding: "10px 15px",
    [theme.breakpoints.down("sm")]: {
      height: 18,
      padding: "8px 10px",
    },
  },
  "& .MuiOutlinedInput-root": {
    borderRadius: 8,
    fontSize: 14,
    width: '100%',
    "& fieldset legend span": {
      display: "none",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: 11,
      borderRadius: 8,
    },
  },
  "& .MuiInputLabel-root": {
    color: "#000",
    position: "relative",
    transform: "none",
    fontSize: "16px",
    marginBottom: 5,
    marginTop: 5,
    display: "flex",
    alignItems: "center",
    pointerEvents: "auto",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "140%",
    // fontFamily: '"Montserrat",sans-serif',
    [theme.breakpoints.down("sm")]: {
      fontWeight: 400,
      fontSize: "9px",
      lineHeight: "144%",
    },
  },
  "& label.Mui-focused": {
    color: theme.palette.primary.main,
  },
  "& label.Mui-error": {
    color: "#C20E30 !important",
    // #C20E30
  },
  "& .MuiSelect-select": {
    height: 25,
    "& .notranslate": {
      display: "block",
      margin: "2.45px 0",
    },
  },
  "& .MuiInputBase-multiline": {
    padding: "0",
  },
  input: {
    "&::placeholder": {
      [theme.breakpoints.down("sm")]: {
        fontWeight: 400,
        fontSize: "10px",
      },
    },
  },
}));

const ContainerVisorCustom = styled(Grid)(({ theme }) => ({
  display: 'grid !important',
  gridTemplateColumns: '50% 50%',
  // gridAutoRows: '100vh !important',
  overflowY: 'auto !important',
  '&::-webkit-scrollbar': {
    width: '0',
    background: 'transparent',
  },
  // minHeight: "100vh",
  overflowX: 'hidden',
  width: '100%',
  // border: '1px solid red !important',
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '100%',
  },
  [theme.breakpoints.up('sm')]: {
    gridTemplateColumns: '100%',
  },
  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: '50% 50%',
  },
}));

const PdfContainerIOS = styled(Box)(({ theme }) => ({
  width: "100%",
  margin: "10px auto",
  border: '1px solid gray',
  '@media only screen and (max-width: 620px) and (min-width: 5px)': {
    height: '52vh',
  },
  overflow: "auto",
  position: "relative",
  "& .react-pdf__Document": {
    backgroundColor: "#888",
    '@media only screen and (max-width: 620px) and (min-width: 5px)': {
      height: '52vh',
    },
    display: "flex",
    flexDirection: "column",
    border: "0.5px solid gray",
  },
  "& .react-pdf__Page": {
    flexGrow: 1,
    display: "block",
    padding: "8px 8px",
  },
  "& .react-pdf__Page__annotations": {
    display: "none",
  },
  "& canvas": {
    padding: "10px 0px",
    margin: "0 auto",
  },
  [theme.breakpoints.down("sm")]: {
    "& .react-pdf__Page": {
      padding: "5px 5px",
    },
    "& canvas": {
    },
  },
}));

const ContainerButton = styled(Box)(({ theme }) => ({
display: 'flex', 
flexDirection: 'column', 
justifyContent: 'center',
marginTop: 5, 
[theme.breakpoints.only('xs')]: { 
marginBottom: 48,
},
// [theme.breakpoints.only('sm')]: {
//   padding: "3px 0.5em",
// },
// [theme.breakpoints.only('md')]: {
//   padding: "5px 7em",
// },
// [theme.breakpoints.only('lg')]: {
//   padding: "6px 9em",
// },
// [theme.breakpoints.only('xl')]: {
//   padding: "8px 11em",
// },
}));

export const SeeDocBeforeLoad = (props) => {
  const matches = useMediaQuery("(max-width:812px)");
  const gridContainer = {} //mainStyles.gridStyle();
  const classes = {} //mainStyles.bodyStyles();
  const visualDoc = {} //mainStyles.docVisualButton();
  const localStyles = useStyles();

  // console.log("SeeDocBeforeLoad props*********************: ", props)
  // const [pages, SetnumPages] = useState([]);
  const [documentInfo, setdocumentInfo] = useState([]);
  const [openEditableForm, setopenEditableForm] = useState(false);
  const formMethods = useForm();
  const { t } = useTranslation();
  const docTypeName = props.documentNameCurrent;
  const docsMetadataFields = {
    INE: ['Nombre(s)', 'CURP', 'Vigencia'],
    CFE: [
      'Nombre',
      // 'Referencia',
      'Dirección',
      // 'RFC',
      'Fecha',
      // 'Calle',
      // 'Número',
      // 'Código Postal',
      // 'Colonia',
      // 'Ciudad',
      // 'Municipio',
      // 'Estado',
      // 'Periodo',
      // 'Total',
    ],
    TELMEX: ['Nombre', 'RFC', 'Fecha', 'Dirección'],
    'Cédula de agente': ['Nombre', 'Tipo de cédula', 'Número de cédula', 'Vigencia'],
  };
  // const setPages = ({ numPages }) => {
  //   for (let i = 1; i < numPages + 1; i++) {
  //     SetnumPages((pages) => [...pages, i]);
  //   }
  // };

  // useEffect(() => {
  //   if (props.sections.length > 1) {
  //     props.setIdSection(props.sections[props.totalSections].Id);
  //     props.setSectionName(props.sections[props.totalSections].Name);
  //   }
  // }, [props.totalSections]);

  useEffect(() => {
    // console.log("props.metadata.length ,props.loading, !props.metaToSend)*********: ", props.metadata.length, props.loading, props.metaToSend);
    if (props.metadata.length > 0 && props.loading && !props.metaToSend) {

      let metadata = props.metadata.filter((el) => !el.GroupName);
      let metadataTables = props.metadata.filter((el) => el.ValueType);
      metadata = metadata.filter((el) => !el.ValueType);
      let docInfo = {
        metadata,
        metadataTables,
      };
      // console.log("Imprime DocInfo*********: ", docInfo);
      setdocumentInfo(docInfo);
      //Se forza para mostrar el modal de edicion de datos
      setopenEditableForm(true)
    } else if (props.metadata.length > 0 && props.loading && props.metaToSend) {
      setdocumentInfo([]);
      props.sendAction();
    }
  }, [props.metadata]);

  useEffect(() => {
    if (Object.keys(documentInfo).length > 0 && props.loading) {
      props.setLoadFile(false);
    }
  }, [documentInfo]);

  const setNewMetadata = (formData) => {
    props.setLoadFile(true);
    // console.log("setNewMetadata.metadata: ***formData***+", formData)
    // console.log("documentInfo.metadata: ", documentInfo.metadata)
    const generalMetadata = documentInfo.metadata.map((meta, i) => {
      return {
        ...meta,
        Value: formData[meta.Name],
      };
    });
    let newData = [...generalMetadata];
    const nameTables = documentInfo.metadataTables.map((el) => el.Name);
    const tablesKeys = nameTables.map((nameTab, i) => {
      let aux = [];
      Object.keys(formData).forEach((keyform) => {
        if (keyform.startsWith(nameTab)) {
          const fields = keyform.split("-");
          aux = [
            ...aux,
            {
              tableName: fields[0],
              fieldName: fields[1],
              order: +fields[2],
              fieldValue: formData[keyform],
            },
          ];
        }
      });
      return aux;
    });

    const groups = tablesKeys.map((tab) => {
      let aux = [];
      tab.forEach((t) => {
        aux[t.order] = [...(aux[t.order] ?? []), t];
      });
      return aux;
    });

    groups.forEach((row, i) => {
      const rows = row.map((r) => {
        return r.map((el) => ({ TextValue: el.fieldValue, Confidence: 1.0 }));
      });
      const table = {
        Columns: JSON.parse(documentInfo.metadataTables[i].Value).Columns,
        Rows: rows,
      };
      newData = [
        ...newData,
        {
          ...documentInfo.metadataTables[i],
          Value: JSON.stringify(table),
        },
      ];
    });

    // console.log("newData**********newData*************************", newData);
    setopenEditableForm(false);
    props.setMetaToSend(true);
    props.setMetadatos(newData);
  };

  if (openEditableForm) {
    return (
      <FormProvider {...formMethods}>
        <EditableModalForm
          openEditableForm={openEditableForm}
          setopenEditableForm={setopenEditableForm}
          metadata={documentInfo.metadata}
          fieldsFormat={props.fields}
          metadataTables={documentInfo.metadataTables}
          doc={props.doc}
          docExt={props.docExt}
          // docType={props.docType}
          setNewMetadata={setNewMetadata}
          folioId={props.folioId}
          docId={props.docId}
          closeAction={props.closeAction}
        />
      </FormProvider>
    );
  }

  return (<GenericDialog open={props.open} onClose={!props.open}
    content={<Box sx={{
      display: 'flex',
      position: 'relative',
      height: '80vh',
    }}>
      <CustomLoadingOverlay
        active={props.loading}
        text={t("general_loading_message")}
      />
      <div className={gridContainer.centerColumn}>
        {Object.keys(documentInfo).length > 0 && props.ocrInfo.ocr != 0 ? (
          <div className={localStyles.modal}>
            {openEditableForm ?
              <FormProvider {...formMethods}>
                <EditableModalForm
                  openEditableForm={openEditableForm}
                  setopenEditableForm={setopenEditableForm}
                  metadata={documentInfo.metadata}
                  metadataTables={documentInfo.metadataTables}
                  fieldsFormat={props.fields}
                  doc={props.doc}
                  docExt={props.docExt}
                  // docType={props.docType}
                  setNewMetadata={setNewMetadata}
                  folioId={props.folioId}
                  docId={props.docId}
                  closeAction={props.closeAction}
                />
              </FormProvider>
              :
              null
            }
          </div>
        ) : null}
      </div>
    </Box>}
  />);
};

const EditableModalForm = (props) => {
  const classes = useClasses();
  const theme = useTheme()
  const location = useLocation()
  const localStyles = {}//useStyles();
  const { control, handleSubmit, watch, setValue, formState, register, setError } = useForm({ mode: 'onBlur' });
  const dispatch = useDispatch()

  const [listMetadata, setListMetadata] = useState([]);
  const [loadPostalCode, setLoadPostalCode] = useState(false)
  const [listColoniaCurrent, setListColoniaCurrent] = useState([]);
  const [loadInitFind, setLoadInitFind] = useState(false)

  const dataSearchCP = useSelector(state => state.Search)
  const { t } = useTranslation();

  useEffect(() => {
    setListMetadata([])
    // console.log("props.metadata original: ", props.metadata)
    // console.log("props.fieldsFormat: ", props.fieldsFormat)
    if (props.metadata?.length > 0 && props.fieldsFormat?.length > 0) {
      // console.log("props.fieldsFormat Entro:  1: ", props.fieldsFormat)
      let newData = [];

      props.metadata?.forEach((data) => {
        let findProps = props.fieldsFormat?.find(
          (field) => data.Name === field.FieldQuestionName
        );
        // console.log("props.findProps 1: ", findProps)
        if (findProps != undefined && findProps != null) {
          if (!findProps?.Visible) {
            return null;
          }
          let nameLabel = findProps.FieldName;
          // console.log("props.fieldsFormat nameLabel.length, nameLabel: findProps.maxLength 1: *******: ", nameLabel.length, nameLabel, findProps.maxLength)
          newData.push({
            ...data,
            MaxLength: findProps.maxLength === undefined || findProps.maxLength === null ? 200 : findProps.maxLength,
            // Label: nameLabel.length > 0 ? nameLabel.toUpperCase() : data.Name.toUpperCase(),
            Label: nameLabel.length > 0 ? nameLabel : data.Name,
            RegexValidation: findProps?.RegexValidation
          })
        } else {
          newData.push({
            ...data,
            MaxLength: 200,
            // Label: data.Name.toUpperCase(),
            Label: data.Name,
            RegexValidation: findProps?.RegexValidation
          })
        }
        // return {
        //   ...data,
        //   Label: nameLabel != undefined && nameLabel != null && nameLabel != "" ? nameLabel : data.Name
        // };
      });
      console.log("props.fieldsFormat newData:  1: ", newData)
      setListMetadata(newData)
    } else {
      let newData = props.metadata.map((data) => {
        return {
          ...data,
          MaxLength: 200,
          Label: data.Name,
          // Label: data.Name.toUpperCase(),
          RegexValidation: null
        };
      });
      console.log("newData 2: ", newData)
      setListMetadata(newData)
    }
  }, [props.fieldsFormat, props.metadata]);

  useEffect(() => {
    if (listMetadata?.length > 0) {
      listMetadata?.forEach(item => {
        // console.log("listMetadata?.forEach: ", item)
        setValue(item.Name, item.Value)
      })
    }
  }, [listMetadata])

  useEffect(() => {
    // setLoadView(dataSearchCP.loading)
    if (dataSearchCP.items != undefined && loadPostalCode) {
      setLoadPostalCode(false)
      let listColonia = dataSearchCP.items?.Body?.find(item => item.Question == "Colonia"
        && item.QuestionGroup == "Comprobante de domicilio")?.Values
      // console.log("listColonia.items: ", listColonia)
      setListColoniaCurrent(listColonia)

      let listCiudad = dataSearchCP.items?.Body?.find(item => item.Question == "Ciudad"
        && item.QuestionGroup == "Comprobante de domicilio")?.Values[0]
      // console.log("listCiudad.items: ", listCiudad)

      let listMunicipio = dataSearchCP.items?.Body?.find(item => item.Question == "Municipio"
        && item.QuestionGroup == "Comprobante de domicilio")?.Values[0]
      // console.log("listMunicipio.items: ", listMunicipio)

      let listEstado = dataSearchCP.items?.Body?.find(item => item.Question == "Estado"
        && item.QuestionGroup == "Comprobante de domicilio")?.Values[0]
      // console.log("listEstado.items: ", listEstado)

      // setFieldValues(dataSearchCP.items)
      setValue("Ciudad", listCiudad);
      setValue("Municipio", listMunicipio);
      setValue("Estado", listEstado);
      setValue("Colonia", listColonia[0]);
      // console.log("Colonia: ", listColonia[0])
      // console.log("dataSearchCP.items: ", dataSearchCP.items)
    } else if (dataSearchCP.error != undefined && loadPostalCode) {
      setLoadPostalCode(false)
      console.log("Error consulta: ", dataSearchCP.error)
    }
  }, [dataSearchCP])

  useEffect(() => {
    // setLoadView(dataSearchCP.loading)
    // console.log("Entro: watchCP:******** ", listMetadata)
    if (listMetadata != null && listMetadata != "" && listMetadata?.length > 4 && loadInitFind == false) {
      let cpFind = listMetadata?.find(item => item.Name == "Código Postal")?.Value;
      // console.log("Entro: watchCP:**cpFind****** ", cpFind)
      GetFindPostalCode(cpFind, "Código Postal", "")
      setLoadInitFind(true)
    }
  }, [listMetadata])

  let GetFindPostalCode = (code, name, group) => {
    // console.log("GetFindPostalCode: code, name, group: ", code, name, group)
    if (code != null && code != "" && code?.length > 4) {
      // console.log("Entro: GetFindPostalCode: code, name, group: ", code, name, group)
      setLoadPostalCode(true)
      let data = {
        File_Id: null,
        Document_Id: null,
        DocumentType_Id: props.docId,
        QuestionGroup: "Comprobante de domicilio",
        Question: `${name}`,
        Value: `${code}`
      }
      // console.log("Request: data: ", data)
      dispatch(executeSearchActions.GetByCodigoPostal(data))
    }
  }

  return (<GenericDialog open={props.openEditableForm} onClose={(event, reason) => {
    // console.log("(event, reason)*****: ", event, reason)
    if (reason && reason == "backdropClick")
      return;
    props.setopenEditableForm(false)
    props.closeAction()
  }}
    title="Edición de datos"
    content={<Box sx={{
      display: 'flex',
      position: 'relative',
      height: '80vh',
    }}>
      <ContainerVisorCustom>
        <Box sx={navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/Android/i) ? { width: '100%', padding: '0.5em' } : {
          width: '100%', padding: '0.5em',
          overflow: 'auto',
          maxHeight: '90vh'
        }}>
          {props.docExt == ".jpg" ||
            props.docExt == ".jpeg" ||
            props.docExt == ".png" ?
            <img alt="" src={props.doc} style={{ width: "100%" }} /> :
            navigator.userAgent.match(/iPhone/i) ?
              <PdfContainerIOS>
                <object id="containerIOS" data={props.doc} type='application/pdf' />
              </PdfContainerIOS>
              : navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/Android/i) ?
                <VisorPDF pdfUrl={props.doc} pdfName={props.FileName ?? ""} height={"70vh"} />
                : <object width="100%" height="100%" data={props.doc} type='application/pdf' />
          }
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            padding: '1em',
            width: '100%'
          }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', width: '100%' }}>
            {listMetadata?.length > 0
              ? listMetadata.map((doc, i) => <>
                {/* {console.log("Metadadata: ITEM: ******:  ", doc)} */}
                <Controller
                  control={control}
                  name={doc.Name}
                  rules={{ required: true }}
                  defaultValue={doc.Value}
                  render={({ field: { ref, ...restFields } }) => (
                    doc.Name == "Código Postal" ?
                      <TextField
                        {...restFields}
                        {...register(doc.Name, {
                          required: "Requerido",
                          minLength: { value: 5, message: 'Código Postal. ej. 54960' }
                        })}
                        required={true}
                        error={!!formState.errors[doc.Name]}
                        helperText={formState.errors[doc.Name]?.message}
                        inputRef={ref}
                        fullWidth
                        autoComplete='new-password'
                        variant="outlined"
                        // InputProps={{ inputComponent: TextMaskCustom }}
                        className={`${localStyles.inputs}`}
                        name={doc.Name}
                        label={doc.Label}
                        onInput={e => {
                          console.log("event12 ", doc.Name, e.target.value)
                          let z1 = /^[0-9]*$/;
                          if (!z1.test(e.target.value)) {
                            console.log("Entro en el control", localStorage.getItem(doc.Name), !z1.test(e.target.value));
                            setValue(doc.Name, localStorage.getItem(doc.Name));
                            setError(doc.Name, "Por favor ingrese solo caracteres numéricos")
                          } else {
                            GetFindPostalCode(e.target.value, doc.Name, doc.GroupName)
                            setValue(doc.Name, e.target.value)
                            localStorage.setItem(doc.Name, e.target.value);
                          }
                        }}
                        // onBlur={e => {
                        //   console.log("event12 ", doc.Name, e.target.value)
                        //   let z1 = /^[0-9]*$/;
                        //   if (!z1.test(e.target.value)) {
                        //     console.log("Entro en el control", localStorage.getItem(doc.Name), !z1.test(e.target.value));
                        //     setValue(doc.Name, localStorage.getItem(doc.Name));
                        //     setError(doc.Name, "Por favor ingrese solo caracteres numéricos")
                        //   } else {
                        //     GetFindPostalCode(e.target.value, doc.Name, doc.GroupName)
                        //     setValue(doc.Name, e.target.value)
                        //     localStorage.setItem(doc.Name, e.target.value);
                        //   }
                        // }}
                        // // onKeyUp={e => GetFindPostalCode(e.target.value, doc.Name, doc.GroupName)}
                        // onKeyDown={e => {
                        //   console.log("event12 ", doc.Name, e.target.value)
                        //   let z1 = /^[0-9]*$/;
                        //   if (!z1.test(e.target.value)) {
                        //     console.log("Entro en el control", localStorage.getItem(doc.Name), !z1.test(e.target.value));
                        //     setValue(doc.Name, localStorage.getItem(doc.Name));
                        //     setError(doc.Name, "Por favor ingrese solo caracteres numéricos")
                        //   } else {
                        //     GetFindPostalCode(e.target.value, doc.Name, doc.GroupName)
                        //     setValue(doc.Name, e.target.value)
                        //     localStorage.setItem(doc.Name, e.target.value);
                        //   }
                        // }}
                        // onChange={e => GetFindPostalCode(e.target.value, doc.Name, doc.GroupName)}
                        InputProps={{
                          // inputComponent: TextMaskCustom,
                          inputProps: {
                            maxLength: doc.MaxLength,
                            style: { textTransform: "uppercase" },
                            outline: 'none',
                            autoComplete: 'new-password',
                            form: {
                              autoComplete: 'off',
                            }
                          }
                        }}
                      />
                      : doc.Name == "Teléfono" ?
                        <TextField
                          {...restFields}
                          {...register(doc.Name, {
                            required: "Requerido",
                            validate: (value) => {
                              return (
                                new RegExp(doc.RegexValidation).test(value) ||
                                `${doc.Name} dato inválido. Número de teléfono a 10 digitos. ej. 5567883730`
                              );
                            },
                            minLength: {
                              value: 10,
                              message: "Número de teléfono a 10 digitos. ej. 5567883730",
                            },
                          })}
                          error={!!formState.errors[doc.Name]}
                          helperText={formState.errors[doc.Name]?.message}
                          placeholder={doc.Label}
                          inputRef={ref}
                          fullWidth
                          className={`${localStyles.inputs}`}
                          label={doc.Label}
                          name={doc.Name}
                          variant="outlined"
                          required={true}
                          autoComplete='new-password'
                          InputProps={{
                            inputProps: {
                              maxLength: doc.MaxLength,
                              style: { textTransform: "uppercase" },
                              outline: 'none',
                              autoComplete: 'new-password',
                              form: {
                                autoComplete: 'off',
                              }
                            }
                          }}
                        />
                        : doc.Name == "Colonia"
                          && listColoniaCurrent?.length > 1 ?
                          <TextField
                            {...restFields}
                            {...register(doc.Name, {
                              required: "Requerido",
                              // setValueAs: (value) => value?.toUpperCase()
                            })}
                            name={doc.Name}
                            required={true}
                            error={!!formState.errors[doc.Name]}
                            helperText={formState.errors[doc.Name]?.message}
                            inputRef={ref}
                            fullWidth
                            variant="outlined"
                            className={`${localStyles.inputs}`}
                            label={doc.Label}
                            select
                            InputProps={{
                              inputProps: {
                                maxLength: doc.MaxLength,
                                style: { textTransform: "uppercase" },
                                outline: 'none',
                                autoComplete: 'new-password',
                                form: {
                                  autoComplete: 'off',
                                }
                              }
                            }}
                          >
                            {/* {console.log("doc.Value: ", listColoniaCurrent)} */}
                            {listColoniaCurrent?.map(i => {
                              // { console.log("i.Value: ", i) }
                              return <MenuItem key={i} value={i}>
                                {i}
                              </MenuItem>
                            }
                            )}
                          </TextField>
                          :
                          <TextField
                            {...restFields}
                            {...register(doc.Name, {
                              required: "Requerido",
                              // setValueAs: (value) => value?.toUpperCase()
                            })}
                            error={!!formState.errors[doc.Name]}
                            helperText={formState.errors[doc.Name]?.message}
                            placeholder={doc.Label}
                            inputRef={ref}
                            fullWidth
                            className={`${localStyles.inputs}`}
                            label={doc.Label}
                            name={doc.Name}
                            variant="outlined"
                            required={true}
                            autoComplete='new-password'
                            InputProps={{
                              inputProps: {
                                maxLength: doc.MaxLength,
                                style: { textTransform: "uppercase" },
                                outline: 'none',
                                autoComplete: 'new-password',
                                form: {
                                  autoComplete: 'off',
                                }
                              }
                            }}
                          />
                  )}
                />
              </>) : null}
          </Box>
          <ContainerButton >
            <Button
              fullWidth
              variant="contained"
              style={{
                maxWidth: 300,
                margin: "20px auto 0 auto",
                display: "block",
                height: '48px',
                borderRadius: '8px',
                backgroundColor: theme.palette.primary.main,
                textTransform: 'capitalize',
                color: "#FFF",
              }}
              onClick={handleSubmit(props.setNewMetadata)}
            >
              {t("general_accept")}
            </Button>
            <Button
              fullWidth
              variant="outlined"
              style={{
                maxWidth: 300,
                margin: "10px auto",
                display: "block",
                height: '48px',
                borderRadius: '8px',
                borderColor: theme.palette.primary.main,
                textTransform: 'capitalize',
                color: theme.palette.primary.main,
              }}
              onClick={() => {
                props.setopenEditableForm(false)
                props.closeAction()
              }}
            >
              {t("general_cancel")}
            </Button>
          </ContainerButton>
        </Box>
      </ContainerVisorCustom>
    </Box>}
  />);
};

const TableEditable = (props) => {
  const classes = useClasses();
  const [dataTable, setdataTable] = useState([]);
  const { control, register, formState } = useFormContext();

  useEffect(() => {
    if (props.data) {
      setdataTable(JSON.parse(props.data.Value));
    }
  }, [props]);

  return (
    <TableContainer component={Paper} elevation={0}>
      <Table>
        <TableHead className={classes.tableHead}>
          <TableRow>
            {dataTable.Columns?.map((col, i) => (
              <TableCell key={col}>{col}</TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {dataTable.Rows?.map((row, i) => (
            <TableRow key={row[0].TextValue}>
              {row.map((cell, j) => (
                <TableCell key={j + cell.TextValue + i}>
                  <Controller
                    control={control}
                    name={`${props.data.Name}-${dataTable.Columns[j]}-${i}`}
                    defaultValue={cell.TextValue}
                    render={({ field: { ref, ...restFields } }) => (
                      <OutlinedInput
                        {...restFields}
                        {...register(props.data.Name, {
                          required: "Requerido",
                          // setValueAs: (value) => value?.toUpperCase()
                        })}
                        error={!!formState.errors[props.data.Name]}
                        helperText={formState.errors[props.data.Name]?.message}
                        inputRef={ref}
                        fullWidth
                        label={props.data.Name}
                        variant="outlined"
                        className={classes.outlinedText}
                      />
                    )}
                  />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

// const TextMaskCustom = React.forwardRef(function TextMaskCustom(props, ref) {
//   return (
//     <IMaskInput
//       {...props}
//       mask="00000"
//       definitions={{
//         "#": /[1-9]/,
//       }}
//       inputRef={ref}
//       overwrite
//     />
//   );
// });

const useClasses = makeStyles((theme) => ({
  modalEditable: {
    paddingLeft: 10,
    paddingTop: 10,
    paddingBottom: 10,
    width: "100%",
    minHeight: "80vh",
  },
  inputText: {
    marginTop: 15,
    /*   display: "block", */
    "& .MuiOutlinedInput-input": {
      // height: 25,
      padding: "10px 15px",
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
      borderColor: theme.palette.primary.main,
      fontSize: 14,
      "& fieldset legend span": {
        display: "none",
      },
    },
    "& .MuiInputLabel-root": {
      color: "#000",
      position: "relative",
      transform: "none",
      fontSize: 14,
      marginBottom: 8,
      marginTop: 5,
      display: "flex",
      alignItems: "center",
      pointerEvents: "auto",
      fontWeight: 500,
    },
    // "& label.Mui-focused": {
    //   color: theme.palette.primary.main,
    // },
  },
  outlinedText: {
    marginTop: 15,
    borderRadius: 8,
    fontSize: 14,
    "& .MuiOutlinedInput-input": {
      height: 25,
      padding: "10px 15px",
    },
  },
  accSummary: {
    "& .MuiAccordionSummary-content": {
      margin: 0,
    },
  },
  tableHead: {
    backgroundColor: "#AAA",
    "& th": {
      color: "#FFF",
    },
  },
  errorInput: {
    // "& fieldset": {
    //   border: `2px solid ${theme.palette.primary.main,}`,
    // },
    "& .MuiFormLabel-root": {
      color: theme.palette.primary.color,
    },
  },
  indicator: {
    color: theme.palette.primary.main,
  },
  capitalize: {
    textTransform: "capitalize !important",
  },
  overFlowModal: {
    overflow: "hidden !important",
    "& .MuiDialog-paperWidthSm": {
      minWidth: '800px !important',
      ['@media only screen and (max-width: 800px)']: {
        minWidth: '320px !important',
      },
    },
    "&MuiPaper-root MuiDialog-paper MuiDialog-paperScrollPaper": {
      overflow: "hidden !important",
    },
  },
}));
